import { supabase } from '../lib/supabase';

/** يجب أن يطابق AuthContext PROFILE_CACHE_KEY */
const PROFILE_CACHE_KEY = 'msh_up_v2';

/**
 * حذف الحساب الذاتي عبر Edge Function user_delete_account.
 * يستخدم supabase.functions.invoke (أكثر موثوقية من fetch + refreshSession).
 */
export async function deleteOwnAccountViaEdgeFunction() {
  const { data, error } = await supabase.functions.invoke('user_delete_account', {
    body: {},
  });

  if (error) {
    const msg =
      error.message ||
      error.context?.msg ||
      (typeof error.context === 'object' && error.context?.error) ||
      'فشل حذف الحساب، يرجى المحاولة لاحقاً.';
    throw new Error(typeof msg === 'string' ? msg : String(msg));
  }

  if (data && typeof data === 'object' && data.error) {
    const err = data.error;
    throw new Error(typeof err === 'string' ? err : err?.message || 'فشل حذف الحساب');
  }

  try {
    localStorage.removeItem(PROFILE_CACHE_KEY);
  } catch (_) {}

  return data;
}
